import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../environments/environment';
import { Tree } from '../shared/models/tree.model';
import { TreeService } from '../shared/services/tree.service';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '../shared/i18n/translate.pipe';


@Component({
    selector: 'app-treeselector',
    templateUrl: './treeselector.component.html',
    styleUrls: ['./treeselector.component.css'],
    providers: [],
    standalone: true,
    imports: [TranslatePipe]
})
export class TreeSelectorComponent implements OnInit, OnDestroy {

  selectedTree!: number;
  treeList: Tree[] = [];
  personCount: number | undefined;
  environment = environment;
  changeTreeSubscription: Subscription | undefined;

  constructor(private treeService: TreeService) { }

  onChangeTree() {
    this.treeService.setCurrentTree(this.selectedTree);
    environment.currentTree = String(this.selectedTree);
  }

  loadTreeStats() {
    if (environment.currentTree) {
      this.treeService.getTreeStats(environment.currentTree).subscribe(
        stats => {
          this.personCount = stats.person_count;
        },
        _error => {
          // Jeśli błąd (np. 403), po prostu nie wyświetlaj licznika
          this.personCount = undefined;
        }
      );
    }
  }

  ngOnInit() {
    /*this.treeService.getTreeList().subscribe(
      (treeList) => {
        this.treeList = treeList;
        // this.selectedTree = treeList.find( res => res.default === true ).id;
        environment.currentTree = String(this.selectedTree);
        this.treeService.setCurrentTree(this.selectedTree);
      });
*/
    this.loadTreeStats();

    this.changeTreeSubscription = this.treeService.changeTree.subscribe((_tree: unknown) => {
      this.loadTreeStats();
    });
  }

  ngOnDestroy() {
    if (this.changeTreeSubscription) {
      this.changeTreeSubscription.unsubscribe();
    }
  }

}
